import React from "react";

const StatCard = ({ title, figure }) => {
  return (
    <div className="new_stat_card__wrapper">
      <div className="new_stat_card__content">
        <div className="t--16 t--500">{title}</div>
        <div className="t--xl t--500">{figure}</div>
      </div>
    </div>
  );
};

export default StatCard;
